import { Card, Col } from "react-bootstrap";

const StatCard = ({ title, value, icon, bgColor, textColor = 'white' }) => (
  <Col xs={6} sm={4} md={3} lg={2} className="mb-4">
    <Card 
      text={textColor.toLowerCase()} 
      className="h-100 shadow-lg"
      style={{
        backgroundColor: `rgba(var(--bs-${bgColor}-rgb), 0.8)`, // Increased opacity for better readability
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
      }}
    >
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <div className="fs-4 opacity-75">
            <i className={`bi ${icon}`}></i>
          </div>
          <div>
            <Card.Title as="h6" className="text-end">{title}</Card.Title>
          </div>
        </div>
        <Card.Text as="h4" className="fw-bold text-end mt-2">{value}</Card.Text>
      </Card.Body>
    </Card>
  </Col>
);

export default StatCard;